var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"material-icons mr-2",on:{"click":function($event){return _vm.saveItem(_vm.item, false)}}},[_vm._v("done")])])}
var staticRenderFns = []

export { render, staticRenderFns }